import { useTranslation } from 'react-i18next';
import React, { useEffect, useState, useRef } from "react";
import Header from "../components/Header";
import { useNavigate } from "react-router-dom";
import NoData from "../components/NoData";
import {alert, confirm} from "../components/MegConfirmAlert";
import { BsSearch, BsFillPinMapFill, BsCameraFill,BsFillPenFill, BsFillTrashFill, BsImages, BsXLg } from "react-icons/bs";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import adrImg from "../images/adrImg.svg";
import { useForm } from "react-hook-form";
import { useAxios } from "../services/useAxios";
import { useDaumPostcodePopup } from 'react-daum-postcode';
import { Map, useNaverMapInit, Marker } from '@r2don/react-naver-map'
import Modal from 'react-bootstrap/Modal';

export default function DelivManagement(props){
    
    const { t } = useTranslation();
    const [data, setData] = useState({});
    const [request] = useAxios();   
    const [mode, setMode] = useState(props.mode?props.mode:'list');
    const [isMapOpen, setMapOpen] = useState(false);
    const {register, handleSubmit, setValue,  reset, formState, clearErrors }= useForm();
    const{errors} = formState;  
    const navigate = useNavigate();
    const open = useDaumPostcodePopup();
    const {isMapLoaded} = useNaverMapInit({ncpClientId: 'lq2nqnl2ej'});
    const userInfo = JSON.parse(localStorage.getItem("user")).data;
    const [tabKey, setTabKey] = useState('tab1');

    const fileInput1 = React.createRef();
    const fileInput2 = React.createRef();

    const [previewImg, setPreviewImg] = useState("");
    const [fileData, setFileData] = useState({});

    const phoneRegex = /^01([0|1|6|7|8|9]?)-?([0-9]{3,4})-?([0-9]{4})$/
    function regPhoneNumber(e) {
        const result = e.target.value
          .replace(/[^0-9.]/g, "")
          .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, "$1-$2-$3")
          .replace(/(-{1,2})$/g, "");

        setValue('dlvyCttpc', result, { shouldValidate: true })          
    }

    const ConfirmDel = async (data) => {
        const result = await confirm(t(`Message.dlvy_info_list_dlvy_remove_confirm`), {okText : t(`Message.common_yes`) , cancelText : t(`Message.common_no`)});
        if(result){
            const response = await request.post("/app/dlvy/rmvDlvyInfoAPI",data);            
            if(response.data.resultCode === 200){
                setData(response.data.result);
                reset({})
                setMode('list')  
            }else{
                alert(response.data.resultMessage);
            }
        }
    }

    const handleComplete = (data) => {
        let addr = '';
        let extraAddr = '';
        
        //사용자가 선택한 주소 타입에 따라 해당 주소 값을 가져온다.
        if (data.userSelectedType === 'R') { // 사용자가 도로명 주소를 선택했을 경우
            addr = data.roadAddress;
        } else { // 사용자가 지번 주소를 선택했을 경우(J)
            addr = data.jibunAddress;
        }

        // 사용자가 선택한 주소가 도로명 타입일때 참고항목을 조합한다.
        if(data.userSelectedType === 'R'){
            // 법정동명이 있을 경우 추가한다. (법정리는 제외)
            // 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.
            if(data.bname !== '' && /[동|로|가]$/g.test(data.bname)){
                extraAddr += data.bname;
            }
            // 건물명이 있고, 공동주택일 경우 추가한다.
            if(data.buildingName !== '' && data.apartment === 'Y'){
                extraAddr += (extraAddr !== '' ? ', ' + data.buildingName : data.buildingName);
            }
            // 표시할 참고항목이 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
            if(extraAddr !== ''){
                extraAddr = ' (' + extraAddr + ')';
            }
            // 조합된 참고항목을 해당 필드에 넣는다.
            setValue("dlvyDetailAdres", extraAddr);
        
        } else {
            setValue("dlvyDetailAdres", '');            
        }

        // 우편번호와 주소 정보를 해당 필드에 넣는다.
        setValue("dlvyZip", data.zonecode);
        setValue("dlvyBassAdres",addr);
        clearErrors('dlvyZip')
        clearErrors('dlvyBassAdres')
      };

    const onSubmit = async data=> {
        data.bassDlvyaraAt = data.baseCheck?"Y":"N"
        data.userId = userInfo.userId
        if(tabKey === 'tab1'){
            if(data.dlvyInfoSn){            
                const response = await request.post("/app/dlvy/modDlvyInfoAPI",data);            
                if(response.data.resultCode === 200){
                    setData(response.data.result);
                    reset({})
                    setMode('list')  
                }else{
                    alert(response.data.resultMessage);
                }
            }else{
                const response = await request.post("/app/dlvy/regDlvyInfoAPI",data);            
                if(response.data.resultCode === 200){
                    setData(response.data.result);
                    reset({})
                    setMode('list')  
                }else{
                    alert(response.data.resultMessage);
                } 
            }
        }else{
            let formData = new FormData();
            formData.append("files", fileData);
            formData.append("dlvyInfoNm", data.dlvyInfoNm);
            formData.append("dlvyNcm", data.dlvyNcm);
            formData.append("dlvyCttpc", data.dlvyCttpc);
            formData.append("dlvyEntrncPass", data.dlvyEntrncPass);
            formData.append("bassDlvyaraAt", data.bassDlvyaraAt);
            formData.append("userId", data.userId);

            const response = await request.post("/app/dlvy/regPicDlvyInfoAPI",formData,{
                headers: {
                  "Content-Type": "multipart/form-data",
                }
              });            
            if(response.data.resultCode === 200){
                setData(response.data.result);
                reset({})
                setPreviewImg("");
                setFileData({})
                setMode('list')  
            }else{
                alert(response.data.resultMessage);
            }  
        }
        
    }

    const movePage = () => {
        if(mode === 'list'){
            if(props.closeFn){
                if(props.selectDlvy){
                    props.selectDlvy(null,data.dlvyInfoList)
                }
                props.closeFn(false)                
            }else{
                navigate(-1);
            }
            
        }else{
            reset({})
            if(props.editData){
                props.closeFn(false)
            }else{
                setMode('list')
            }
            
        }
    }
    
    const fn_selectDlvy = (obj) => {
        if(props.selectDlvy){
            props.selectDlvy(obj,data.dlvyInfoList)
        }
    }
 

    const fn_fileRemove = () => {
        setPreviewImg("");
    }
    const fn_fileSel = (e) =>{
       
        let fileArr = e.target.files;    
       
        for(let i = 0; i < fileArr.length; i++){    
            setFileData(fileArr[i])             
            const reader = new FileReader();
            reader.readAsDataURL(fileArr[i]);
            reader.onload = function(){
                setPreviewImg(reader.result); 
                              
            }
        };
    }

    const fetchData = async () => {
        const response = await request.post("/app/dlvy/getDlvyInfoAPI",{           
        });            
        if(response.data.resultCode === 200){            
            setData(response.data.result);
        }
    };

    useEffect(() => {
        fetchData();
        
      }, []);
    return (
        <div className={props.modal?'modalPage':'justPage'}>
            <div className="backGround bgBlue"></div>

            <Header type={props.modal?'modal':'cart'} handleBack={movePage} closeFn={movePage} newItem pageTitle={t(`Message.my_salee_screen_dlvy_manage`)}/>
                    
            {mode=== 'list' ? ( 
            <>  
            {data.dlvyInfoList && data.dlvyInfoList.length === 0?(
                <div className="floatCenter">
                    <NoData text={t(`Message.dlvy_info_list_empty_dlvy`)}/>
                </div> 
            ):(
            <ul className="adrListWr">
                {data.dlvyInfoList && data.dlvyInfoList.map((obj, index) => (  
                <li className="adrList" key={index} onClick={(e)=>fn_selectDlvy(obj)}>
                    <div className="radioWr">
                        <input type="radio" name="aa" id={"sel"+index} defaultChecked={props.checkDlvy?(props.checkDlvy===obj.dlvyInfoSn):(obj.bassDlvyaraAt === 'Y')}/>
                        <label htmlFor={"sel"+index}></label>
                    </div>
                    <div className="delvInfo">
                        {obj.bassDlvyaraAt === 'Y'?(
                        <p className="seleted">{t(`Message.dlvy_info_list_dflt_adres`)}</p>
                        ):null}
                        <h3 className="nick">{obj.dlvyInfoNm}</h3>
                        {obj.dlvyAtchmnfl?(
                        <img alt={obj.replcTextCn} src={"https://www.salee.co.kr/com/cmm/getDlvyInfoImage.sale?userId="+obj.dlvyAtchmnfl.userId+"&dlvyInfoSn="+obj.dlvyAtchmnfl.dlvyInfoSn} />
                        ):(
                            <>
                        <p className="adrDetail">{obj.dlvyBassAdres} {obj.dlvyDetailAdres}</p>
                        </>
                        )}
                        <div className="dfcsG12">
                            <p>{obj.dlvyNcm}</p>
                            <p>{obj.dlvyCttpc}</p>
                            {obj.dlvyEntrncPass?(<p>{obj.dlvyEntrncPass}🔔</p>):null}
                        </div>
                     
                    </div>                    
                    <div className="dfceG6">
                        {!obj.dlvyAtchmnfl?(
                        <div className="btn2424 pen" onClick={(e) => {reset({...obj , 'baseCheck':obj.bassDlvyaraAt==='Y'});                                      
                         setMode('edit'); e.stopPropagation();}}>
                            <BsFillPenFill />
                        </div>
                        ):null}
                        {obj.bassDlvyaraAt !== 'Y'?(
                        <button className="btn2424 del" onClick={(e) => { ConfirmDel(obj); e.stopPropagation();}}> 
                            <BsFillTrashFill />
                        </button>
                        ):null}
                    </div>
                </li>
                ))}
            </ul>
            )}
                
            <div className="floatBtn" onClick={async (e) => { reset({}); setMode('edit');}}>{t(`Message.dlvy_info_regist_title`)}</div>
            </>
        ):(
           
            <div>

            <div className="txtC pt16">
                <img src={adrImg} alt={t(`Message.my_order_hist_detail_dlvy_dest`)} />
            </div>

            <form onSubmit={handleSubmit(onSubmit)}>
                <ul className="adrForm">
                    <li>
                        <p className="tit">{t(`Message.dlvy_info_regist_alias`)}</p>
                        <input type="text" maxLength={60}  placeholder={t(`Message.dlvy_info_regist_hint_alias`)} {...register("dlvyNcm", { required: t(`Message.dlvy_info_regist_required_alias`) })}/>
                        {errors.dlvyNcm && <p role="alert" className="alertRed">{errors.dlvyNcm.message}</p>}
                    </li>
                    <li>
                        <p className="tit">{t(`Message.dlvy_info_regist_recpt`)}</p>
                        <input type="text" maxLength={50}  placeholder={t(`Message.dlvy_info_regist_hint_recpt`)} {...register("dlvyInfoNm", { required: t(`Message.dlvy_info_regist_required_recpt`) })} />
                        {errors.dlvyInfoNm && <p role="alert" className="alertRed">{errors.dlvyInfoNm.message}</p>}
                    </li>
                    <li>
                        <p className="tit">{t(`Message.dlvy_info_regist_contact`)}</p>
                        <input type="tel" maxLength={13}  placeholder={t(`Message.dlvy_info_regist_invalid_contact`)} {...register("dlvyCttpc",{ onChange: (e) => {regPhoneNumber(e)}, required: t(`Message.ordrr_form_required_mobile`), pattern: {value: phoneRegex, message: "올바른 휴대폰 형식이 아닙니다."}})}/>
                        {errors.dlvyCttpc && <p role="alert" className="alertRed">{errors.dlvyCttpc.message}</p>}
                    </li>
                    <li>
                        <Tabs
                            id="controlled-tab-example"
                            activeKey={tabKey}
                            onSelect={(k) => setTabKey(k)}
                            className="tabType1"
                            >
                            <Tab eventKey="tab1" title={t(`Message.dlvy_info_regist_adres_tab_direct_input`)}>
                                <div className="modalTabWr">
                                    <div className="dfcsG12 pt10">
                                        <button type="button" className="greenB cFFF btn36" onClick={(e)=>open({ onComplete: handleComplete })}><BsSearch /> {t(`Message.dlvy_info_regist_adres_search`)}</button>
                                        <button type="button" className="line btn36" onClick={(e)=>setMapOpen(true)}><BsFillPinMapFill /> {t(`Message.dlvy_info_regist_find_current_loc`)}</button>
                                    </div>
                                    {tabKey === 'tab1'? (
                                    <div className="dfColG4 pt16">
                                        <p className="tit mb8">{t(`Message.dlvy_info_regist_adres`)}</p>
                                        <input type="text" {...register("dlvyZip", { required:t(`Message.dlvy_info_regist_required_adres`)})}  disabled/>
                                        {errors.dlvyZip && <p role="alert" className="alertRed">{errors.dlvyZip.message}</p>}
                                        <input type="text" {...register("dlvyBassAdres", { required:t(`Message.dlvy_info_regist_required_adres`)})}  disabled/>
                                        {errors.dlvyBassAdres && <p role="alert" className="alertRed">{errors.dlvyBassAdres.message}</p>}
                                        <input type="text" placeholder={t(`Message.dlvy_info_regist_hint_dtl_adres`)}{...register("dlvyDetailAdres", {})} />
                                        {errors.dlvyDetailAdres && <p role="alert" className="alertRed">{errors.dlvyDetailAdres.message}</p>}
                                    </div>
                                    ):null}
                                </div>
                            </Tab>
                            <Tab eventKey="tab2" title={t(`Message.dlvy_info_regist_adres_tab_photo_regist`)}>
                                <div className="modalTabWr">
                                    <div className="dfcsG12 pt10">
                                        <button type="button" className="greenB cFFF btn36" onClick={(e)=> fileInput1.current.click() }><BsCameraFill /> {t(`Message.dlvy_info_regist_take_photo`)}</button>
                                        <button type="button" className="line btn36" onClick={(e)=> fileInput2.current.click() }><BsImages /> {t(`Message.dlvy_info_regist_select_photo`)}</button>
                                        <input type="file" accept="image/*" onChange={fn_fileSel} capture="environment" ref={fileInput1} style={{ display: "none" }} />
                                        <input type="file" accept="image/*" onChange={fn_fileSel} ref={fileInput2} style={{ display: "none" }} />
                                    </div>
                                    <div className="thumWr">
                                        {previewImg?(
                                            <>
                                        <button type="button" className="delBtn" onClick={fn_fileRemove}><BsXLg /></button>
                                        <img alt="미리보기" src={previewImg} />
                                            </>
                                        ):null}
                                    </div>
                                </div>
                            </Tab>
                        </Tabs> 
                    </li>
                    <li>
                        <p className="tit">{t(`Message.dlvy_info_regist_entrnc_pass`)}</p>
                        <input type="text" {...register("dlvyEntrncPass", { })} placeholder={t(`Message.dlvy_info_regist_hint_entrnc_pass`)} />
                    </li>
                </ul>
                <div className="chkWr pl20 pb20">
                    <input type="checkbox" name="baseCheck" id="adrSave" {...register("baseCheck", { })} />
                    <label htmlFor="adrSave">{t(`Message.dlvy_info_regist_save_dflt_adres`)}</label>
                </div>
                <div className="pd20">
                    <button type="submit" className="btn48 cFFF orgB fs16">{t(`Message.saveBtn`)}</button>    
                </div>
            </form>

            <Modal
                className="btModal"
                show={isMapOpen}
                onHide={setMapOpen}
                fullscreen={true}
                aria-labelledby="contained-modal-title-vcenter"
                centered                
                keyboard={false}
                >
               <Header type="modal" pageTitle={t(`Message.naver_map_current_location_title`)} closeFn={setMapOpen}/>
               <div className="pd20">
                {isMapLoaded?(
               <Map center={{latitude: 37.3595704, longitude: 127.105399}} style={{height: '500px', width: '500px'}}>
               
                </Map>
                ):(
                    <div>지도호출 실패</div>
                )}
                </div>
            </Modal>
            </div>
            )}
        </div>
    ); 
};